export enum FillablePDFsConstants {
  SAVE_FILLABLE_PDF = 'fillablePDFs/SAVE_FILLABLE_PDF',
  GET_FILLABLE_PDFS = 'fillablePDFs/GET_FILLABLE_PDFS',
  SET_FILLABLE_PDFS = 'fillablePDFs/SET_FILLABLE_PDFS',
  SET_CURRENT_STEP = 'fillablePDFs/SET_CURRENT_STEP',
  SET_AUTHOR = 'fillablePDFs/SET_AUTHOR',
  SET_CUSTOM_INPUTS = 'fillablePDFs/SET_CUSTOM_INPUTS',
  ADD_FILLABLE_PDF = 'fillablePDFs/ADD_FILLABLE_PDF',
  REMOVE_FILLABLE_PDF = 'fillablePDFs/REMOVE_FILLABLE_PDF',
  SET_FILLABLE_PDF = 'fillablePDFs/SET_FILLABLE_PDF',
  RESET_FILLABLE_PDFS = 'fillablePDFs/RESET_FILLABLE_PDFS',
  RESET_FILLABLE_PDFS_ON_CHART_EXIT = 'fillablePDFs/RESET_FILLABLE_PDFS_ON_CHART_EXIT',
  INITIALIZE_FILLABLE_PDF = 'fillablePDFs/INITIALIZE_FILLABLE_PDF',
  DELETE_FILLABLE_PDF = 'fillablePDFs/DELETE_FILLABLE_PDF',
  SET_FILLABLE_PDFS_LIST = 'fillablePDFs/SET_FILLABLE_PDFS_LIST',
  SET_SHOW_MODAL = 'fillablePDFs/SET_SHOW_MODAL',
  SET_PDF_ID = 'fillablePDFs/SET_PDF_ID',
  HYDRATE_FILLABLE_PDF_FROM_PCR = 'fillablePDFs/HYDRATE_FILLABLE_PDF_FROM_PCR',
  SET_FILLABLE_PDFS_IMPORT_ERROR = 'fillablePDFs/SET_FILLABLE_PDFS_IMPORT_ERROR',
  ON_FILLABLE_PDFS_IMPORT_SUCCESS = 'fillablePDFs/ON_FILLABLE_PDFS_IMPORT_SUCCESS',
  SET_FILLABLE_PDF_DATA = 'fillablePDFs/SET_FILLABLE_PDF_DATA',
  SET_PDF_NAME = 'fillablePDFs/SET_PDF_NAME',
  LOAD_PDF_FROM_DEVICE = 'fillablePDFs/LOAD_PDF_FROM_DEVICE',
  SET_PDF_URL = 'fillablePDFs/SET_PDF_URL',
  SET_PDF_LOADING = 'fillablePDFs/SET_PDF_LOADING',
  SET_PDF_ERROR = 'fillablePDFs/SET_PDF_ERROR',
  GET_PDF_ATTACHMENTS = 'fillable/GET_PDF_ATTACHMENTS',
}

export enum PdfRenderStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  COMPLETE = 'complete',
  ERROR = 'error',
}
